<script lang="ts">
  import Tr from "../Base/Tr.svelte"
  import Translations from "../i18n/Translations"
  import { XCircleIcon } from "@babeard/svelte-heroicons/solid"
  import type { SpecialVisualizationState } from "../SpecialVisualization"
  import ArrowPath from "@babeard/svelte-heroicons/mini/ArrowPath"
  import { createEventDispatcher } from "svelte"

  export let failed: number
  export let state: SpecialVisualizationState
  const t = Translations.t.image
  let dispatch = createEventDispatcher<{ retry }>()
</script>

<div class="alert flex">
  <div class="flex w-full flex-col items-start items-center">
    {#if failed === 1}
      <Tr t={t.upload.one.failed} />
    {:else}
      <Tr t={t.upload.multiple.someFailed.Subs({ count: failed })} />
    {/if}
    <Tr cls="text-normal" t={t.upload.failReasons} />
    <Tr cls="text-xs" t={t.upload.failReasonsAdvanced} />
    {#if state}
      <button class="primary pointer-events-auto" on:click={() => dispatch("retry")}>
        <ArrowPath class="w-6" />
        <Tr t={Translations.t.general.retry} />
      </button>
    {/if}
  </div>
  <button
    class="pointer-events-auto mt-2 h-fit shrink-0 rounded-full border-none p-0"
    on:click
    style="border: 0 !important; padding: 0 !important;"
  >
    <XCircleIcon aria-hidden={true} class="h-8 w-8" />
  </button>
</div>
